import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { ActivityDataSave } from './activity-data-save';
import { IConfigState, IResultState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IActivityDataSaveStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
  readonly result: IResultState;
}

export type IActivityDataSaveConnectProps = IActivityDataSaveStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IActivityDataSaveStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    result: state.result
  };
}

export const ActivityDataSaveContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(ActivityDataSave);
